<template>
    <div class='conter'>
        <div class="flex_cen_cen page_heard">
            <div :class="tabType=='1' ? 'choose_cla box_cla' : 'box_cla'" @click="tabType = 1 ">
                海 鸥 云
            </div>
            <div :class="tabType=='2' ? 'choose_cla box_cla' : 'box_cla'" @click="tabType = 2 ">
                人 如 云
            </div>
            <div :class="tabType=='3' ? 'choose_cla box_cla' : 'box_cla'" @click="tabType = 3 ">
                速速云签
            </div>
        </div>
        <div class="bai"></div>
        <div  class="page_cont">
            <div class="charts-top">              
                <div class="flex_sta_cen" style="width:60%">
                        <div class="heard_text" >访问量</div>
                        <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 24px;"></DatePicker>
                    </div>
                <div  class="flex_spw_sta">                    
                    <div style="width:60%;margin-right:10px">
                        <div class="main-chart ">
                            <div id="main" style="width:100%;height: 300px;"></div>                        
                        </div>
                    </div>
                    <div class="echarts_right_box">
                        <div style="width:100%;height:300px;">
                            <div style="">
                                <Table :columns="echartsTableData.columns" :data="echartsTableData.data" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="echartsTableData.total" :current="echartsTableData.pageNo" @on-change="pageChange" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
        <div class="tab_cla">
            <div v-if="tabType == 1">
                <div class="tab_con">
                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">学生数</div>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard flex_cen_cen">
                                123456
                            </div>
                            <div class="tab_wid">
                                <Table :columns="seagullTableData.columns1" :data="seagullTableData.data1" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="seagullTableData.total1" :current="seagullTableData.pageNo1" @on-change="pageChange($event,1,1)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>
                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">考勤人数</div>
                            <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 24px;"></DatePicker>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard_cur flex_cen_cen">
                                123456
                                <div class="icon_cla" style="" @click="showCategory"><Icon type="ios-stats-outline" size="25" /></div>  
                            </div>
                            <div class="tab_wid ">
                                <Table :columns="seagullTableData.columns2" class="cur_cla" :data="seagullTableData.data2" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="seagullTableData.total2" :current="seagullTableData.pageNo2" @on-change="pageChange($event,1,2)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>
                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">老师数量</div>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard flex_cen_cen">
                                123456
                            </div>
                            <div class="tab_wid">
                                <Table :columns="seagullTableData.columns3" :data="seagullTableData.data3" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="seagullTableData.total3" :current="seagullTableData.pageNo3" @on-change="pageChange($event,1,3)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>
                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">交易额度</div>
                            <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 24px;"></DatePicker>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard_cur flex_cen_cen">
                                123456
                                <div class="icon_cla" style="" @click="showCategory"><Icon type="ios-stats-outline" size="25" /></div>  
                            </div>
                            <div class="tab_wid ">
                                <Table :columns="seagullTableData.columns4" class="cur_cla" :data="seagullTableData.data4" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="seagullTableData.total4" :current="seagullTableData.pageNo4" @on-change="pageChange($event,1,4)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>
                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">学校数</div>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard flex_cen_cen">
                                123456
                            </div>
                            <div class="tab_wid">
                                <Table :columns="seagullTableData.columns5" :data="seagullTableData.data5" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="seagullTableData.total5" :current="seagullTableData.pageNo5" @on-change="pageChange($event,1,5)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>
                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">课程数量</div>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard flex_cen_cen">
                                123456
                            </div>
                            <div class="tab_wid">
                                <Table :columns="seagullTableData.columns6" :data="seagullTableData.data6" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="seagullTableData.total6" :current="seagullTableData.pageNo6" @on-change="pageChange($event,1,6)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>
                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">短信数量</div>
                            <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 24px;"></DatePicker>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard_cur flex_cen_cen">
                                123456
                                <div class="icon_cla" style="" @click="showCategory"><Icon type="ios-stats-outline" size="25" /></div>  
                            </div>
                            <div class="tab_wid ">
                                <Table :columns="seagullTableData.columns7" class="cur_cla" :data="seagullTableData.data7" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="seagullTableData.total7" :current="seagullTableData.pageNo7" @on-change="pageChange($event,1,7)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>

                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">流量</div>
                            <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 24px;"></DatePicker>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard_cur flex_cen_cen">
                                123456
                                <div class="icon_cla" style="" @click="showCategory"><Icon type="ios-stats-outline" size="25" /></div>  
                            </div>
                            <div class="tab_wid ">
                                <Table :columns="seagullTableData.columns8" class="cur_cla" :data="seagullTableData.data8" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="seagullTableData.total8" :current="seagullTableData.pageNo8" @on-change="pageChange($event,1,8)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>
                </div>            
            </div>
            <!-- //人如云 -->
            <div v-if="tabType == 2">
                <div class="tab_con">
                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">订单数</div>
                            <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 24px;"></DatePicker>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard flex_cen_cen cur_cla">
                                123456
                                <div class="icon_cla" style="" @click="showCategory"><Icon type="ios-stats-outline" size="25" /></div>  
                            </div>
                            <div class="tab_wid">
                                <Table :columns="restaurantTableData.columns1" class="cur_cla" :data="restaurantTableData.data1" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="restaurantTableData.total1" :current="restaurantTableData.pageNo1" @on-change="pageChange($event,2,1)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>
                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">下单人数</div>
                            <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 24px;"></DatePicker>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard_cur flex_cen_cen">
                                123456
                                <div class="icon_cla" style="" @click="showCategory"><Icon type="ios-stats-outline" size="25" /></div>  
                            </div>
                            <div class="tab_wid ">
                                <Table :columns="restaurantTableData.columns2" class="cur_cla" :data="restaurantTableData.data2" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="restaurantTableData.total2" :current="restaurantTableData.pageNo2" @on-change="pageChange($event,2,2)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>
                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">客户数</div>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard flex_cen_cen">
                                123456
                            </div>
                            <div class="tab_wid">
                                <Table :columns="restaurantTableData.columns3" :data="restaurantTableData.data3" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="restaurantTableData.total3" :current="restaurantTableData.pageNo3" @on-change="pageChange($event,2,3)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>
                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">会员人数</div>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard flex_cen_cen">
                                123456
                            </div>
                            <div class="tab_wid ">
                                <Table :columns="restaurantTableData.columns4"  :data="restaurantTableData.data4" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="restaurantTableData.total4" :current="restaurantTableData.pageNo4" @on-change="pageChange($event,2,4)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>
                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">销售额</div>
                            <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 24px;"></DatePicker>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard cur_cla flex_cen_cen">
                                123456
                                <div class="icon_cla" style="" @click="showCategory"><Icon type="ios-stats-outline" size="25" /></div>  
                            </div>
                            <div class="tab_wid">
                                <Table :columns="restaurantTableData.columns5" class="cur_cla" :data="restaurantTableData.data5" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="restaurantTableData.total5" :current="restaurantTableData.pageNo5" @on-change="pageChange($event,2,5)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>
                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">店铺数</div>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard flex_cen_cen">
                                123456
                            </div>
                            <div class="tab_wid">
                                <Table :columns="restaurantTableData.columns6" :data="restaurantTableData.data6" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="restaurantTableData.total6" :current="restaurantTableData.pageNo6" @on-change="pageChange($event,2,6)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>
                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">充值金额</div>
                            <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 24px;"></DatePicker>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard_cur flex_cen_cen">
                                123456
                                <div class="icon_cla" style="" @click="showCategory"><Icon type="ios-stats-outline" size="25" /></div>  
                            </div>
                            <div class="tab_wid ">
                                <Table :columns="restaurantTableData.columns7" class="cur_cla" :data="restaurantTableData.data7" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="restaurantTableData.total7" :current="restaurantTableData.pageNo7" @on-change="pageChange($event,2,7)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>

                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">硬件数量</div>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard flex_cen_cen">
                                123456
                            </div>
                            <div class="tab_wid ">
                                <Table :columns="restaurantTableData.columns8"  :data="restaurantTableData.data8" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="restaurantTableData.total8" :current="restaurantTableData.pageNo8" @on-change="pageChange($event,2,8)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>
                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">桌台数</div>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard flex_cen_cen">
                                123456
                            </div>
                            <div class="tab_wid ">
                                <Table :columns="restaurantTableData.columns9"  :data="restaurantTableData.data9" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="restaurantTableData.total9" :current="restaurantTableData.pageNo9" @on-change="pageChange($event,2,9)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>
                </div>            
            </div>   
            <!-- 速速云签  contractTableData      -->
            <div v-if="tabType == 3">
                <div class="tab_con">
                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">合同份数</div>
                            <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 24px;"></DatePicker>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard flex_cen_cen cur_cla">
                                123456
                                <div class="icon_cla" style="" @click="showCategory"><Icon type="ios-stats-outline" size="25" /></div>  
                            </div>
                            <div class="tab_wid">
                                <Table :columns="contractTableData.columns1" class="cur_cla" :data="contractTableData.data1" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="contractTableData.total1" :current="contractTableData.pageNo1" @on-change="pageChange($event,3,1)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>
                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">子账户</div>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard flex_cen_cen">
                                123456
                            </div>
                            <div class="tab_wid ">
                                <Table :columns="contractTableData.columns2" class="" :data="contractTableData.data2" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="contractTableData.total2" :current="contractTableData.pageNo2" @on-change="pageChange($event,3,2)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>
                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">参与者数量</div>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard flex_cen_cen">
                                123456
                            </div>
                            <div class="tab_wid">
                                <Table :columns="contractTableData.columns3" :data="contractTableData.data3" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="contractTableData.total3" :current="contractTableData.pageNo3" @on-change="pageChange($event,3,3)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>
                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">支付金额</div>
                            <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 24px;"></DatePicker>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard_cur flex_cen_cen">
                                123456
                                <div class="icon_cla" style="" @click="showCategory"><Icon type="ios-stats-outline" size="25" /></div>  
                            </div>
                            <div class="tab_wid ">
                                <Table :columns="contractTableData.columns4" class="cur_cla" :data="contractTableData.data4" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="contractTableData.total4" :current="contractTableData.pageNo4" @on-change="pageChange($event,3,4)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>
                    <div class="tab_item">
                        <div class="tab_heard flex_sta_cen">
                            <div class="heard_text">短信数量</div>                            
                            <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 24px;"></DatePicker>
                        </div>
                        <div class="tab_tab">
                            <div class="item_heard flex_cen_cen cur_cla">
                                123456
                                <div class="icon_cla" style="" @click="showCategory"><Icon type="ios-stats-outline" size="25" /></div>  
                            </div>
                            <div class="tab_wid">
                                <Table :columns="contractTableData.columns5" class="cur_cla" :data="contractTableData.data5" >
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ index+1 }}</strong>
                                    </template>
                                </Table>
                                <br />
                                <Page :total="contractTableData.total5" :current="contractTableData.pageNo5" @on-change="pageChange($event,3,5)" show-total show-elevator style="text-align:right" />   
                            </div>
                        </div>
                    </div>
                </div>            
            </div>
        </div>    
        <Modal v-model="showEchartsModal" width="610" :mask-closable="false" footer-hide>    
                <div id="ref_charts" style="width:600px;height: 500px"></div>     
        </Modal>   
        
    </div>
</template>

<script>
import { index_legend_statics } from '../../api/index'
import * as echarts from 'echarts';
export default {
    data(){
        return{
            tabType: 1,
            myChart: "",
            showEchartsModal:false,
            myChart_source:[],
            myChart_options:{
                title: {                    
                    text: ''
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: []
                },
                grid: {
                    left: '0',
                    right: '0',
                    bottom: '0',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                    saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: []
                },
                yAxis: {
                    type: 'value'
                },
                series: []
            },
            //echarts 表格
            echartsTableData:{
                data: [],
                columns: [
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '平台名称',key: 'account',align: 'center'},        
                    {title: '访问次数',key: 'account',align: 'center'}, 
                    {title: '访问人数',key: 'account',align: 'center'},             
                ],
                pageSize: 20,
                pageNo: 1,
                total: 1 ,
                start_time: '',
                end_time: '',
            },
            //海鸥云表格
            seagullTableData:{
                data1: [],
                data2: [],
                data3: [],
                data4: [],
                data5: [],
                data6: [],
                data7: [],
                data8: [],
                columns1:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '学校名称',key: 'account',align: 'center'},        
                    {title: '数量',key: 'account',align: 'center'},   
                ],
                columns2:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '学校名称',key: 'account',align: 'center'},        
                    {title: '数量',key: 'account',align: 'center'}, 
                ],
                columns3:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '学校名称',key: 'account',align: 'center'},        
                    {title: '数量',key: 'account',align: 'center'}, 
                ],
                columns4:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '学校名称',key: 'account',align: 'center'},        
                    {title: '交易额',key: 'account',align: 'center'}, 
                ],
                columns5:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '学校名称',key: 'account',align: 'center'},        
                    {title: '分校数量',key: 'account',align: 'center'}, 
                ],
                columns6:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '学校名称',key: 'account',align: 'center'},        
                    {title: '课程数量',key: 'account',align: 'center'}, 
                ],
                columns7:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '学校名称',key: 'account',align: 'center'},        
                    {title: '数量',key: 'account',align: 'center'}, 
                ],
                columns8:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '学校名称',key: 'account',align: 'center'},        
                    {title: '数量',key: 'account',align: 'center'}, 
                ],
                pageNo1: 1,
                pageNo2: 1,
                pageNo3: 1,
                pageNo4: 1,
                pageNo5: 1,
                pageNo6: 1,
                pageNo7: 1,
                pageNo8: 1,
                total1: 0,
                total2: 0,
                total3: 0,
                total4: 0,
                total5: 0,
                total6: 0,
                total7: 0,
                total8: 0,
                pageSize:20,
            },
            //人如云表格
            restaurantTableData:{
                data1: [],
                data2: [],
                data3: [],
                data4: [],
                data5: [],
                data6: [],
                data7: [],
                data8: [],
                data9: [],
                columns1:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '平台名称',key: 'account',align: 'center'},        
                    {title: '订单数',key: 'account',align: 'center'},   
                ],
                columns2:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '平台名称',key: 'account',align: 'center'},        
                    {title: '数量',key: 'account',align: 'center'}, 
                ],
                columns3:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '平台名称',key: 'account',align: 'center'},        
                    {title: '数量',key: 'account',align: 'center'}, 
                ],
                columns4:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '平台名称',key: 'account',align: 'center'},        
                    {title: '人数',key: 'account',align: 'center'}, 
                ],
                columns5:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '平台名称',key: 'account',align: 'center'},        
                    {title: '销售额',key: 'account',align: 'center'}, 
                ],
                columns6:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '平台名称',key: 'account',align: 'center'},        
                    {title: '店铺数',key: 'account',align: 'center'}, 
                ],
                columns7:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '平台名称',key: 'account',align: 'center'},        
                    {title: '充值金额',key: 'account',align: 'center'}, 
                ],
                columns8:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '平台名称',key: 'account',align: 'center'},        
                    {title: '数量',key: 'account',align: 'center'}, 
                ],
                columns9:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '平台名称',key: 'account',align: 'center'},        
                    {title: '桌台数',key: 'account',align: 'center'}, 
                ],
                pageNo1: 1,
                pageNo2: 1,
                pageNo3: 1,
                pageNo4: 1,
                pageNo5: 1,
                pageNo6: 1,
                pageNo7: 1,
                pageNo8: 1,
                pageNo9: 1,
                total1: 0,
                total2: 0,
                total3: 0,
                total4: 0,
                total5: 0,
                total6: 0,
                total7: 0,
                total8: 0,
                total9: 0,
                pageSize:20,
            },
            // 速速云签表格
            contractTableData : {
                data1: [],
                data2: [],
                data3: [],
                data4: [],
                data5: [],
                columns1:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '平台名称',key: 'account',align: 'center'},        
                    {title: '合同份数',key: 'account',align: 'center'},   
                ],
                columns2:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '平台名称',key: 'account',align: 'center'},        
                    {title: '数量',key: 'account',align: 'center'}, 
                ],
                columns3:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '平台名称',key: 'account',align: 'center'},        
                    {title: '数量',key: 'account',align: 'center'}, 
                ],
                columns4:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '平台名称',key: 'account',align: 'center'},        
                    {title: '支付金额',key: 'account',align: 'center'}, 
                ],
                columns5:[
                    {title: '排名',slot: 'index',align: 'center'},
                    {title: '平台名称',key: 'account',align: 'center'},        
                    {title: '销售额',key: 'account',align: 'center'}, 
                ],
                pageNo1: 1,
                pageNo2: 1,
                pageNo3: 1,
                pageNo4: 1,
                pageNo5: 1,
                total1: 0,
                total2: 0,
                total3: 0,
                total4: 0,
                total5: 0,
                pageSize:20,
            },
            ref_charts:"",
            ref_charts_data:[],
            ref_charts_type:1, // 1 代表 用户数  2代表营业额
            ref_charts_option:{
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: [],
                        type: 'bar',
                        label:{
                            show:true
                        }
                    }
                ]
            },
        }
    },
    mounted() {
        this.legendStatics()
    },
    methods:{
        showCategory(){
            this.showEchartsModal = true;
            this.changeCategory()
        },
        changeCategory(){
            if (!this.ref_charts) {
                let chartDom = document.getElementById('ref_charts');
                this.ref_charts = echarts.init(chartDom);
            }
            let header_data = [], header_name = [];
           
            if (this.ref_charts_type == 1) {
                this.header_data.forEach(item => {
                    if(item.system_application.id > 0) {
                        header_name.push(item.system_application.name)
                        header_data.push(item.user_num)
                    }
                });
            } else {
                
                this.header_data.forEach(item=> {
                    if(item.system_application.id != 0) {
                        header_name.push(item.system_application.name)
                        header_data.push(item.money)
                    }
                });
            }
            this.ref_charts_option.xAxis.data = header_name
            this.ref_charts_option.series[0].data = header_data
            this.ref_charts.setOption(this.ref_charts_option, true);
        },
        pageChange(e,type,index){
            // type 1 海鸥云  2 人如云   3  速速云签
            this.echartsTableData.pageNo = e
            // this.getList()
        },
        legendStatics(){
            index_legend_statics({month:this.month}).then(res=>{
                this.myChart_source = res.data
                this.changeCircle()
            })
        },
        changeCircle(){
            if (!this.myChart) {
                let chartDom = document.getElementById('main');
                this.myChart = echarts.init(chartDom);
            }
            this.myChart_options.xAxis.data = this.myChart_source.date;
            let myChart_data = []
            if (this.echartsType == 1) {
                this.myChart_source.data.forEach(item=>{
                    if (item.application_id > 0) {
                        myChart_data.push({
                            name: item.name,
                            type: 'line',
                            smooth: true,
                            data: item.user_num
                        });
                    }
                    
                })
            } else {
                this.myChart_source.data.forEach(item=>{
                    if (item.application_id != 0) {
                        myChart_data.push({
                            name: item.name,
                            type: 'line',
                            smooth: true,
                            data: item.money
                        });
                    }
                })
            }
            this.myChart_options.legend.data = myChart_data.map(item => item.name)
            this.myChart_options.series = myChart_data
            this.myChart.setOption(this.myChart_options, true);
        },
    }

}
</script>

<style lang="scss" scoped>
.tab_item {
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    padding: 20px; 
    margin: 10px 10px;
    background:  #fff;
    // border:1px solid #E4EAF9;
}
.icon_cla {
    margin-left: 24px;
    cursor: pointer;
    position: absolute;
    right: 0;
}
.tab_con {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
}
.charts-top{
    background: #fff;
    padding:15px 30px 30px;
    .echarts_right_box {
        width: 30%;
        border-left: 1px solid #E4EAF9;
        padding-left: 20px ;
    }
    .flex_sta{
        justify-content:space-between;
        text-align: center;
    }
}
.tab_cla {
    margin-top:20px ;
    padding: 20px;
    background-color: #fff;
    
    // background: rgb(236,236,248);
}
.flex_sta_cen {
    display: flex;
    justify-content: flex-start!important;
    align-items: center;
}
.tab_tab {
    margin-top: 20px;
    width: 400px;
}
.item_heard {
    width: 100%;
    text-align: center;
    font-size: 16px;
    position: relative;
    color: #17233d;
    border-bottom: 1px solid #e8eaec ;
}
.cur_cla{
    cursor: pointer;
}
.item_heard_cur {
    width: 100%;
    text-align: center;
    cursor: pointer;
    font-size: 16px;
    position: relative;
    color: #17233d;
    border-bottom: 1px solid #e8eaec ;
}
.tab_wid {
    margin-top:8px;
}
.heard_text {
    font-size: 16px;
    font-weight: 800;
    color: #17233d;
}
.conter {
    background: #f5f7f9;    
    background: rgb(236,236,248);
    min-height: 100vh;
}
.bai {
    height: 100px;
    width: 100%;
}
.page_cont {
    padding: 20px;
    // margin-top: 120px;
    background: #fff;
}
.page_heard {
    background-color: #fff;
    width: 100%;
    height: 80px;
    border-bottom: 1px  solid #e8eaec;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
}
.choose_cla {
    color: #FF761D!important;;    
}
.box_cla {
    text-align: center;
    font-size: 24px;
    cursor: pointer;
    padding: 20px;
    margin:  0 20px;
    color: #17233d;;
}
.no_choose {
    text-align: 26px;
}
.flex_spw_cen {
    display: flex;
    justify-content:space-between;
    align-items: center;
}
.flex_cen_cen {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>